import axios from 'axios';
import { toast } from 'react-toastify';

let sessionToastShown = false;
let redirectInProgress = false;

const clearAuthState = (instance) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('adminLogged');
  localStorage.removeItem('onBehalfName');
  if (instance?.defaults?.headers?.common?.Authorization) {
    delete instance.defaults.headers.common.Authorization;
  }
};

const isLoginCall = (requestUrl = '') => /\/users\/login(\?|$)/.test(requestUrl);

const handleUnauthorized = (instance, code) => {
  clearAuthState(instance);

  if (!sessionToastShown) {
    sessionToastShown = true;
    const message =
      code === 'SESSION_INVALIDATED'
        ? 'Session expired. Please login again.'
        : 'Your session has expired. Please login again.';
    toast.info(message);
    setTimeout(() => {
      sessionToastShown = false;
    }, 2000);
  }

  if (!redirectInProgress && window.location.pathname !== '/login') {
    redirectInProgress = true;
    window.location.href = '/login';
  }
};

const http = (() => {
  function SingletonClass() {
    let url = '';
    if (typeof process.env.REACT_APP_API_LINK == 'undefined') {
      if (
        window.location.origin.includes('http://localhost') ||
        window.location.origin.includes('http://127.0.0.1')
      ) {
        url = 'http://localhost:5000/api/';
      } else {
        url = `${window.location.origin}/api/`;
      }
    } else {
      url = process.env.REACT_APP_API_LINK;
    }

    const instance = axios.create({
      baseURL: url,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    });
    if (localStorage.getItem('access_token')) {
      instance.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${localStorage.getItem('access_token')}`;
    }

    instance.interceptors.request.use(
      function (config) {
        const access_token = localStorage.getItem('access_token');
        if (access_token && !isLoginCall(config.url)) {
          config.headers['Authorization'] = `Bearer ${access_token}`;
        } else if (config.headers?.Authorization) {
          delete config.headers.Authorization;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      function (response) {
        if (redirectInProgress) {
          redirectInProgress = false;
        }
        return response;
      },
      function (error) {
        const status = error?.response?.status;
        const code = error?.response?.data?.code;
        const requestUrl = error?.config?.url || '';

        const isAuthFailure =
          (status === 401 && !isLoginCall(requestUrl)) ||
          (status === 403 && code === 'SESSION_INVALIDATED');

        if (isAuthFailure) {
          handleUnauthorized(instance, code);
        } else if (status === 403) {
          const message =
            error?.response?.data?.message ||
            'You do not have permission to perform this action.';
          toast.error(message);
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }

  var instance;

  return {
    getInstance: function () {
      if (!instance) {
        instance = new SingletonClass();
        delete instance.constructor;
      }
      return instance;
    },
  };
})();

export default http.getInstance();
